export default __webpack_public_path__ + "static/media/ops.6018d0eb.png";